(() => {
  'use strict';
  function mount(page) {
    if(page.dataset.pcReady)return;
    const root=page.querySelector('[data-pair-experience]'),form=root?.querySelector('form');
    const data=page.querySelector('[data-studio-data]');
    if(!form||!data)return;
    let signs;try{signs=JSON.parse(data.textContent).signs;}catch{return;}
    if(signs?.length!==12)return;
    const controller=new AbortController(),events={signal:controller.signal};
    const compact=matchMedia('(max-width: 600px)'),tablist=root.querySelector('[role=tablist]');
    const orient=()=>tablist.setAttribute('aria-orientation',compact.matches?'horizontal':'vertical');
    orient();compact.addEventListener('change',orient);
    const $=selector=>root.querySelector(selector),tabs=[...root.querySelectorAll('[data-pc-tab]')];
    const fields={spark:'ease',tension:'friction',horizon:'horizon'};
    const put=(selector,value)=>{const node=$(selector);if(node)node.textContent=value;};
    const sentences=text=>String(text).match(/[^.!?]+[.!?]+(?:[”’"])?|[^.!?]+$/g)?.map(s=>s.trim()).filter(Boolean)||[text];
    function selectTheme(key,focus=false){
      for(const tab of tabs){const active=tab.dataset.pcTab===key;tab.setAttribute('aria-selected',String(active));tab.tabIndex=active?0:-1;if(active&&focus)tab.focus();}
      root.querySelectorAll('[data-pc-panel]').forEach(panel=>panel.hidden=panel.dataset.pcPanel!==key);
    }
    function updatePractice(){
      const text=$('[data-pair-practice]').textContent;
      put('[data-pc-step]',sentences(text).at(-1));
    }
    function update(){
      const a=Number(form.elements.namedItem('first').value),b=Number(form.elements.namedItem('second').value);
      if(!Number.isInteger(a)||!Number.isInteger(b)||!signs[a]||!signs[b])return;
      put('[data-pc-elements]',signs[a][2]+' + '+signs[b][2]);put('[data-pc-modes]',signs[a][3]+' + '+signs[b][3]);
      put('[data-pc-offer-signs]',signs[a][0]+' & '+signs[b][0]);
      put('[data-pc-offer-first-glyph]',$('[data-pair-glyph-first]').textContent);put('[data-pc-offer-second-glyph]',$('[data-pair-glyph-second]').textContent);
      for(const [side,index] of [['first',a],['second',b]]){
        put('[data-pc-sign-'+side+']',signs[index][0]+' · '+signs[index][2]+' · '+signs[index][3]);
        put('[data-pc-style-'+side+']',signs[index][4]);put('[data-pc-question-'+side+']',signs[index][5]);
      }
      for(const [key,field] of Object.entries(fields))put('[data-pc-summary="'+key+'"]',sentences($('[data-pair-'+field+']').textContent)[0]);
      updatePractice();
    }
    function resetReading(){selectTheme('spark');root.querySelectorAll('[data-pc-panel] details,.pc-sign-details').forEach(node=>node.open=false);update();}
    form.addEventListener('change',event=>{if(event.target.matches('[data-sign-select]'))resetReading();},events);
    form.addEventListener('reset',()=>queueMicrotask(resetReading),events);
    form.addEventListener('submit',()=>{root.querySelector('[data-pc-depth]')?.remove();},{...events,capture:true});
    form.addEventListener('submit',()=>{
      resetReading();
      const extra=$('[data-reading-depth]');
      if(extra&&!extra.parentElement.matches('[data-pc-depth]')){
        const disclosure=document.createElement('details'),summary=document.createElement('summary');
        disclosure.dataset.pcDepth='';summary.textContent='More reflection prompts & notes';
        extra.before(disclosure);disclosure.append(summary,extra);
      }
    },events);
    root.addEventListener('click',event=>{
      const tab=event.target.closest('[data-pc-tab]');if(tab)selectTheme(tab.dataset.pcTab);
      if(event.target.closest('[data-pair-theme]'))updatePractice();
    },events);
    root.querySelector('[role=tablist]').addEventListener('keydown',event=>{
      const i=tabs.indexOf(event.target);if(i<0)return;
      let next;if(['ArrowDown','ArrowRight'].includes(event.key))next=(i+1)%tabs.length;
      if(['ArrowUp','ArrowLeft'].includes(event.key))next=(i+tabs.length-1)%tabs.length;
      if(event.key==='Home')next=0;if(event.key==='End')next=tabs.length-1;
      if(next!==undefined){event.preventDefault();selectTheme(tabs[next].dataset.pcTab,true);}
    },events);
    document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(page)){controller.abort();compact.removeEventListener('change',orient);delete page.dataset.pcReady;}},events);
    page.dataset.pcReady='true';update();
  }
  const init=()=>document.querySelectorAll('[data-pc-page]').forEach(mount);
  init();document.addEventListener('shopify:section:load',init);
})();
